import Client from './Clients/AxiosClient'
const resource = '/api/v1/admin/ptn'

export default {
  get(params) {
    return Client.get(resource, { params })
  },
  show(id) {
    return Client.get(`${resource}/${id}`)
  },
  create(payload) {
    return Client.post(resource, payload)
  },
  update(payload, id) {
    return Client.put(`${resource}/${id}`, payload)
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`)
  },
}
